import { TessaTarget } from "@cmp-src/tessa/AskTessaProvider";
import { ContentBlock } from "@cmp-src/form/MentionTextarea/types";

export const convertTessaTargetsToMentions = (targets: TessaTarget[]) => {
  const mentionsData: ContentBlock[] = [];

  targets.forEach((target) => {
    if (target.type === "user") {
      mentionsData.push({
        id: target.id,
        label: target.label,
        type: "user"
      });
    }
  });

  return mentionsData;
};

export const convertStringToContentBlocks = (text: string): ContentBlock[] => {
  if (!text || text.trim() === "") {
    return [];
  }

  return [
    {
      type: "text",
      text: text
    }
  ];
};
